
import React from 'react';
import { ShippingDetails } from './order-types';
import { Truck, PackageSearch, MessageSquare } from 'lucide-react';

interface ShippingDetailsProps {
  shippingDetails: ShippingDetails | null | undefined;
}

const ShippingDetailsDisplay: React.FC<ShippingDetailsProps> = ({ shippingDetails }) => {
  if (!shippingDetails) return null;
  
  return (
    <div className="bg-blue-50 dark:bg-blue-900/20 p-3 rounded-md mt-2">
      <h4 className="font-medium text-sm mb-2 flex items-center text-blue-700 dark:text-blue-300">
        <Truck size={16} className="mr-2" />
        Informacioni i Transportit
      </h4>
      
      <div className="space-y-2 text-sm">
        <div className="flex items-start">
          <div className="font-medium min-w-28">Kompania Transportuese:</div>
          <div>{shippingDetails.carrier}</div>
        </div>
        
        {shippingDetails.trackingNumber && (
          <div className="flex items-start">
            <div className="font-medium min-w-28 flex items-center">
              <PackageSearch size={14} className="mr-1" />
              Numri i Gjurmimit:
            </div>
            <div className="flex-1">{shippingDetails.trackingNumber}</div>
          </div>
        )}
        
        {shippingDetails.shippingNotes && (
          <div className="flex items-start">
            <div className="font-medium min-w-28 flex items-center">
              <MessageSquare size={14} className="mr-1" />
              Shënime:
            </div>
            <div className="flex-1">{shippingDetails.shippingNotes}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ShippingDetailsDisplay;
